import { Icon } from "@proda-ai/ui-kit";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type FormBadgeStatus = "valid" | "invalid" | "warning" | "empty";

export type FormBadgeProps = BoxProps & {
    status?: FormBadgeStatus;
};

const FormBadge = (props: FormBadgeProps) => {
    const { status = "empty", ...boxProps } = props;
    type IconOptions = "circle" | "circle-check" | "circle-exclamation";
    const { colour, icon }: { colour: string; icon: IconOptions } =
        status === "valid"
            ? { colour: "var(--proda-green-120)", icon: "circle-check" }
            : status === "invalid"
              ? { colour: "var(--proda-red-120)", icon: "circle-exclamation" }
              : status === "warning"
                ? { colour: "var(--proda-yellow-120)", icon: "circle-check" }
                : { colour: "var(--disabled-bg)", icon: "circle" }; // empty
    return (
        <Box {...boxProps}>
            <Icon color={colour} icon={icon} />
        </Box>
    );
};

export default FormBadge;
